// The company details and bank details on a quotation / proforma come from
// master data (Company Profile, Bank Details). The forms show them read-only;
// these helpers say what is missing and where to fix it.

export const COMPANY_PROFILE_PATH = '/app/settings/company'
export const BANK_DETAILS_PATH = '/app/settings/master-data/bank-details'

/** Classes that make an input look and behave as locked. */
export const LOCKED_INPUT_CLASS =
  '!bg-slate-50 dark:!bg-slate-800/60 !text-slate-600 dark:!text-slate-300 cursor-not-allowed focus:!ring-0 focus:!border-slate-200'

const blank = (value?: string | null) => !String(value ?? '').trim()

export interface CompanyValues {
  name?: string | null
  address?: string | null
  gstin?: string | null
}

export interface BankValues {
  accountName?: string | null
  accountNumber?: string | null
  bankName?: string | null
  ifsc?: string | null
}

/** The company details a document cannot go out without, by label. */
export function missingCompanyDetails(values: CompanyValues): string[] {
  const missing: string[] = []
  if (blank(values.name)) missing.push('Company name')
  if (blank(values.address)) missing.push('Registered office address')
  if (blank(values.gstin)) missing.push('GSTIN')
  return missing
}

/** The bank details a document cannot go out without, by label. */
export function missingBankDetails(values: BankValues): string[] {
  const missing: string[] = []
  if (blank(values.accountName)) missing.push('Account name')
  if (blank(values.accountNumber)) missing.push('Account number')
  if (blank(values.bankName)) missing.push('Bank name')
  if (blank(values.ifsc)) missing.push('IFSC code')
  return missing
}

export interface MasterDataIssues {
  company: string[]
  bank: string[]
}

export const hasMasterDataIssues = (issues: MasterDataIssues) => issues.company.length > 0 || issues.bank.length > 0

/** One sentence for a toast when saving is blocked. */
export function describeMasterDataIssues(issues: MasterDataIssues): string {
  const parts: string[] = []
  if (issues.company.length > 0) parts.push(`Company Profile: ${issues.company.join(', ')}`)
  if (issues.bank.length > 0) parts.push(`Bank Details: ${issues.bank.join(', ')}`)
  return parts.length > 0 ? `Complete these in Settings first. ${parts.join(' · ')}.` : ''
}
